module.exports = __webpack_public_path__ + "static/media/calvin-klein-euphoria-women-big.93053a15.png";